export default __webpack_public_path__ + "static/media/Gloves of Ferine Anger.7b801256.jpg";